import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { FileService } from "../../services/file-service";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { Picking } from "..";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class PickingService {
  private API_PIQUEO_URL = environment.API_URL + "api/Orders/piqueo";
  private API_PIQUEO_EXCEL_EXPORT_URL = environment.API_URL + "api/Orders/downloadsinpiqueo";
  private API_PIQUEO_IMPORT_MATERIALS_POSITION = environment.API_URL + "api/Products/uploadmaterialsposition";
  private API_PIQUEO_EXPORT_MATERIALS_POSITION = environment.API_URL + "api/Products/downloadmaterialsposition";
  private API_PIQUEO_EXPORT_TRANSPORT = environment.API_URL + "api/Orders/downloadlapartopiqueo";
  private API_PIQUEO_IMPORT_LIQUIDACION1 = environment.API_URL + "api/users/files/route";
  private API_PIQUEO_EXPORT_LIQUIDACION1 = environment.API_URL + "api/users/files/route";

  constructor(private http: HttpClient, private fileService: FileService, private httpUtils: HttpUtilsService) {}

  findPicking(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const url = this.API_PIQUEO_URL + "/find";
    return this.http.post<QueryResultsModel>(url, queryParams, { headers: httpHeaders });
  }

  getPicking(id): Observable<any> {
    return this.http.get(this.API_PIQUEO_URL + "/" + id);
  }

  deletePicking(id: any) {
    return this.http.delete<any>(`${this.API_PIQUEO_URL}/${id}`);
  }

  cancelPicking(data) {
    const url = this.API_PIQUEO_URL + "/statuscancelled";
    return this.http.post(url, data);
  }

  dismissDebt(data) {
    const url = this.API_PIQUEO_URL + "/statusreadyforinvoicing";
    return this.http.post(url, data);
  }

  export(data) {
    let url = `${this.API_PIQUEO_EXCEL_EXPORT_URL}`;
    return this.exportExcel(data, url, "post");
  }

  exportExcel(data, url, method) {
    if (method === "get") {
      return this.http.get(url, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], { type: "application/vnd.ms-excel" });
        })
      );
    } else {
      return this.http.post(url, data, { responseType: "blob" }).pipe(
        map((res) => {
          return new Blob([res], { type: "application/vnd.ms-excel" });
        })
      );
    }
  }

  importMaterialsPosition(element) {
    return this.fileService.fileUpload(element, this.API_PIQUEO_IMPORT_MATERIALS_POSITION);
  }

  downloadMaterialsPosition(data) {
    let url = `${this.API_PIQUEO_EXPORT_MATERIALS_POSITION}`;
    return this.exportExcel(data, url, "post");
  }

  exportPickingTransport(data) {
    let url = `${this.API_PIQUEO_EXPORT_TRANSPORT}`;
    return this.exportExcel(data, url, "post");
  }

  importLiquidacion1Transporte(element) {
    return this.fileService.fileUpload(element, this.API_PIQUEO_IMPORT_LIQUIDACION1);
  }

  exportLiquidacion1Transporte(data: any) {
    let url = `${this.API_PIQUEO_EXPORT_LIQUIDACION1}/${data.campaignId}/${data.zone}/${data.transportId}`;
    return this.exportExcel(data, url, "get");
  }
}
